import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes'

//store
import store from '../store/index.js'
// import { component } from 'vue/types/umd.js'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
